import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect, useRef } from 'react';
import { getLeaderboardSocket } from '@/libs/leaderboardSocket.client';
import { leaderBoardsKeys } from '../api/leaderBoardsKeys';
import type { ILeaderBoardResponse } from '../types/ILeaderBoardResponse';
export interface UseLeaderboardSocketProps {
  enabled?: boolean;
  onLeaderboardUpdate?: (data: ILeaderBoardResponse) => void;
}

/**
 * @description Hook for subscribing to global leaderboard WebSocket events
 */
export const useLeaderboardSocket = ({
  enabled = true,
  onLeaderboardUpdate
}: UseLeaderboardSocketProps) => {
  const queryClient = useQueryClient();
  const onLeaderboardUpdateRef = useRef(onLeaderboardUpdate);
  onLeaderboardUpdateRef.current = onLeaderboardUpdate;
  const handleLeaderboardSnapshot = useCallback((payload: ILeaderBoardResponse) => {
    queryClient.setQueryData(leaderBoardsKeys.global(), payload);
    queryClient.invalidateQueries({
      queryKey: leaderBoardsKeys.current()
    });
    onLeaderboardUpdateRef.current?.(payload);
  }, [queryClient]);
  useEffect(() => {
    if (!enabled) return;
    const socket = getLeaderboardSocket();
    if (!socket) return;
    socket.emit('subscribe_active_leaderboard');
    socket.on('leaderboard_snapshot', handleLeaderboardSnapshot);
    socket.on('connect_error', err => {
      console.error('❌ leaderboard socket connect error', err);
    });
    return () => {
      socket.off('leaderboard_snapshot', handleLeaderboardSnapshot);
      socket.emit('unsubscribe_active_leaderboard');
    };
  }, [enabled, handleLeaderboardSnapshot]);
};